import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';

const APPLE_JS_SRC =
  'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

export const Route = createFileRoute('/auth/apple/callback')({
  component: AppleCallbackRoute,
});

/**
 * Relay target for Apple's POPUP Sign-In flow (VITE_APPLE_REDIRECT_URI must point here).
 * Apple's server POSTs the auth result to this URL inside the popup window, not the opener.
 * Loading the SDK here lets it detect the popup context, postMessage the result back to
 * useAppleAuth's `signIn()` promise on the opener, and close the popup itself. Never renders
 * visible content — it only needs to exist and load the script.
 */
function AppleCallbackRoute() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = APPLE_JS_SRC;
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return null;
}
